import React, { Suspense, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import withTranslations from 'app/components/HOGs/withTranslations';
// REDUX
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
// PROP TYPE
import { NavBar } from 'antd-mobile';
import { Drawer, Menu, Button, Skeleton } from 'antd';

import { setStateUserEnter } from 'app/actions/Users/user.enter.action';

import 'antd-mobile/dist/antd-mobile.less';
import '../../Desctop/Sign/sign.css';
import './menu.css';

import { createMenu } from '../../Desctop/MainMenu/Newmenu';

import { MenuSvg, CancelSvg } from '../../Desctop/MainMenu/svg';

import { userActions } from '../../../actions/Users/user.sign.action';
import {
  loginModalOpen,
  loginIsLogin,
} from '../../../actions/Login/login.action';

import { retry } from '../../Utility/loadingChunkErrorHandler';

import RightContent from './components/RightContent';
import TourstartAcademy from '../../Desctop/TourstartAcademy/academy';
import '../../Desctop/TourstartAcademy/academy.css';

const MainSearch = React.lazy(() =>
  retry(() =>
    import(/* webpackChunkName: "search" */ '../../Desctop/Search/mainSearch')
  )
);

const sidebar = (props) => (
  <div className="mobileMenuLayout">
    <Menu
      mode="inline"
      theme="light"
      defaultOpenKeys={props.defaultOpenKeys}
      selectedKeys={props.selectedKeys}
      onSelect={props.onSelect}
      onOpenChange={props.onOpenChange}
      openKeys={props.openKeys}
      items={createMenu(props.dataMainMenu, props)}
    />
  </div>
);

const MobileMenu = (props) => {
  const requestFinished = () => {
    // setConfirm(true);
  };

  useEffect(() => {
    props.autologin(requestFinished);
  }, []);

  const getAcademyFromStrSearch = (str) => {
    const index = str.indexOf('academy');
    return index > -1;
  };

  const style = {
    minHeight: document.documentElement.clientHeight,
    width: props.mobileDrawerWidth,
  };

  const getLeftContent = () => {
    const skelet = () => (
      <Skeleton
        size="large"
        title={false}
        paragraph={{ rows: 1, width: '150px' }}
        className="main-search-skeleton"
      />
    );

    return (
      <Suspense fallback={skelet()}>
        <MainSearch />
      </Suspense>
    );
  };

  return (
    <div>
      {getAcademyFromStrSearch(useLocation().search) ? (
        <div className="mobile_academy">
          <TourstartAcademy />
        </div>
      ) : null}
      <NavBar
        icon={
          props.mobileOpen ? (
            <Button
              style={{
                border: 'none',
                margin: 0,
                padding: 0,
                width: '24px',
                height: '22px',
              }}
              onClick={props.onMobileOpenChange}
            >
              <CancelSvg />
            </Button>
          ) : (
            <Button
              style={{
                border: 'none',
                margin: 0,
                padding: 0,
                width: '24px',
                height: '22px',
              }}
              onClick={props.onMobileOpenChange}
            >
              <MenuSvg />
            </Button>
          )
        }
        leftContent={getLeftContent()}
        rightContent={<RightContent {...props} />}
        className="mobileNavBar"
      />
      <Drawer
        className="my-drawer"
        style={style}
        visible={props.mobileOpen}
        placement="left"
        onClose={props.onMobileOpenChange}
        width={250}
        zIndex={1001}
        getContainer={false}
        closable={false}
      >
        <div>{sidebar(props)}</div>
      </Drawer>
    </div>
  );
};

const mapStateToProps = (store) => {
  return {
    dataLogin: store.loginData,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      autologin: userActions.autologin,
      loginModalOpen,
      isLoginChange: loginIsLogin,
      setStateUserEnter,
    },
    dispatch
  );
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslations(MobileMenu));

MobileMenu.displayName = 'MobileMenu';
